import { useRef } from 'react';
import { ACTIVE_FILTER_DELIMITER } from '../filter-and-sort';
import { FilterAndSorterRendererProps } from '../filter-and-sort/FilterAndSorterRendererProps';

export interface GlossaryData {
  hindiTitle?: string;
  englishTitle: string;
  englishContent?: string;
  hindiContent?: string;
}

export function GlossaryNavigator<T>({
  filters,
  activeFilters,
  addFilter,
  clearAllFilters,
}: FilterAndSorterRendererProps<T>) {
  const divRef = useRef<HTMLDivElement>(null);
  const [active] = activeFilters;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <div className="text-2xl font-bold">Navigator</div>
        {active !== undefined && (
          <div
            className="text-primary text-body-1 grid cursor-pointer place-items-center font-semibold"
            onClick={clearAllFilters}
          >
            Clear Filters
          </div>
        )}
      </div>
      <div className="text-grey-500 mt-4 grid grid-cols-7 gap-4" ref={divRef}>
        {filters.map((filter) =>
          filter.filterGroup.map((fg, idx) => {
            return (
              <div
                key={fg.displayName + idx.toString()}
                onClick={() => addFilter(filter.groupName + '~' + fg.value)}
                className={`${
                  activeFilters.has('alphabet' + ACTIVE_FILTER_DELIMITER + fg.value)
                    ? 'bg-primary rounded-small text-white '
                    : ''
                } flex cursor-pointer items-center justify-center py-1 px-3`}
              >
                {(fg.displayName || fg.value).toUpperCase()}
              </div>
            );
          }),
        )}
      </div>
    </div>
  );
}
